import React from 'react';
import classNames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';
import './styles.scss';
import { Tooltip } from '@doxyme/ui';
export function BackgroundEffectsItem({ index, onSelect, selected, title, label, icon, thumbnail, disabled, tooltip, }) {
    const intl = useIntl();
    const children = (<li role="radio" data-index={index} aria-checked={selected} aria-disabled={disabled} aria-label={intl.formatMessage({ id: title })} className={classNames('background_effects__item', {
            'background_effects__item--selected': selected,
            'background_effects__item--transform': index > 2,
            'background_effects__item--with-image': Boolean(thumbnail),
        })} style={{ backgroundImage: thumbnail ? `url('${thumbnail}')` : 'none' }} onClick={disabled ? undefined : onSelect}>
      {icon && (<img src={icon} alt={intl.formatMessage({ id: title })} width={24} height={24}/>)}
      {label ? <FormattedMessage id={label}/> : null}
    </li>);
    return (<>
      {tooltip ? (<Tooltip content={<>
              <b>{tooltip.title}</b>
              <p>{tooltip.description}</p>
              {tooltip.linkText && tooltip.linkHref && (<a id="backgroundEffects.options.branded.disabled" href={tooltip.linkHref} target="_blank" rel="noreferrer" className="is-dark">
                  {tooltip.linkText}
                </a>)}
            </>} size="medium" theme="dark" pointerPosition="top-center" hideTimeout={0} debounceMs={0}>
          {children}
        </Tooltip>) : (children)}
    </>);
}
